.Carousel {
    :global(.swiper-wrapper) {
        height: auto;
    }

    :global(.swiper-slide) {
        width: auto;
        height: inherit !important;
    }

    :global(.swiper-pagination) {
        display: flex;
        justify-content: center;
        align-items: center;
        width: fit-content !important;
        left: 50% !important;
        transform: translateX(-50%);
        padding: 8px 16px;
        gap: 4px;
        background: var(--color-primary-dark-5);
        border-radius: 9999px;
    }

    :global(.swiper-pagination-bullet) {
        width: 4px;
        height: 4px;
        background-color: var(--color-antracite);
        opacity: 0.25;
        border-radius: 9999px;
        margin: 0 !important;
        transition: all 0.3s ease;
    }

    :global(.swiper-pagination-bullet-active) {
        width: 16px;
        height: 4px;
        background: var(--color-antracite);
        opacity: 1;
    }
}

:global(.instruction-swiper) {
    height: 100%;
    overflow: visible !important;

    :global(.swiper-wrapper) {
        height: 100%;
    }

    :global(.swiper-slide) {
        width: 100%;
        height: 100% !important;
        overflow: visible;
    }
}

:global(.instruction-carousel) {
    :global(.swiper-pagination) {
        left: 0 !important;
        transform: none;
        display: flex;
        gap: 4px;
        background: transparent;
        border-radius: 0;
        padding: 0 24px;
        width: 100% !important;
        box-sizing: border-box;
    }

    --swiper-pagination-bottom: 32px;

    :global(.swiper-pagination-bullet) {
        flex: 1;
        height: 3px;
        width: auto;
        border-radius: 2px;
        background-color: rgba(255, 255, 255, 0.25);
        opacity: 1;
        margin: 0 !important;
        transition: background-color 0.3s ease;
    }

    :global(.swiper-pagination-bullet-active) {
        background-color: #fff;
        opacity: 1;
    }
}
